import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver} from '@/utils/baseUrl';

export async function changeDueTime(params) {
    return post(erpserver+'/bids/changeDueTime', params, true)
}
/*20250331*/
//发布
export async function publishTender(params) {
    return post(erpserver+'/tender/publishTender', params, true)
}
//新增编辑供应商
export async function saveSupplier(params) {
    return post(erpserver+'/tender/saveSupplier', params, true)
}
//供应商列表
export async function supplierList(params) {
    return post(erpserver+'/tender/supplierList', params, true)
}
//用户列表
export async function bmuids(params) {
    return post(erpserver+'/tender/bmuids', params, true)
}
//招标类型
export async function tenderType(params) {
    return post(erpserver+'/tender/tenderType', params, true)
}
//列表
export async function tenderlist(params) {
    return post(erpserver+'/tender/list', params, true)
}
//新增招标
export async function tendersave(params) {
    return post(erpserver+'/tender/save', params, true)
}
//开标
export async function openTender(params) {
    return post(erpserver+'/tender/openTender', params, true)
}
/**/
export async function bidsList(params) {
    return post(erpserver+'/bids/list', params, true)
}
export async function dict(params) {
    return post(erpserver+'/bids/dict', params, true)
}
export async function save(params) {
    return post(erpserver+'/bids/save', params, true)
}
export async function fail(params) {
    return post(erpserver+'/bids/fail', params, true)
}
//报价列表
export async function offerlist(params) {
    return post(erpserver+'/bids/offerlist', params, true)
}
//i_req_subid列表
export async function subIds(params) {
    return post(erpserver+'/bids/subIds', params, true)
}
//报价公司
export async function getKhsByBid(params) {
    return post(erpserver+'/bids/getKhsByBid', params, true)
}
//招标品种
export async function listPzsByBid(params) {
    return post(erpserver+'/bids/getPzsByBid', params, true)
}
export async function flowSub(params) {
    return post(oaserver+'/flow/flowSub', params, true)
}
export async function detaiList(params) {
    return post(erpserver+'/bids/detailList', params, true)
}
export async function confirm(params) {
    return post(erpserver+'/bids/confirm', params, true)
}
export async function stopAccept(params) {
    return post(erpserver+'/bids/stopAccept', params, true)
}
//申购单列表
export async function applyBuyList(params) {
    return post(erpserver+'/applybuy/applyBuyList', params, true)
}
//申购单保存
export async function saveApplyBuy(params) {
    return post(erpserver+'/applybuy/saveApplyBuy', params, true)
}
//申购单详情
export async function applybuyDetail(params) {
    return post(erpserver+'/applybuy/detail', params, true)
}
//申购品种
export async function getPzListBySx(params) {
    return post(erpserver+'/applybuy/getPzListBySx', params, true)
}
//线下采购
export async function transToOffline(params) {
    return post(erpserver+'/applybuy/transToOffline', params, true)
}
//产品属信
export async function pzsxList(params) {
    return post(erpserver+'/applybuy/pzsxList', params, true)
}
// 获取申购请人
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true);
}
// 获取申购部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
// 获取申购公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 定向供应商
export async function gykhList(params) {
    return post(erpserver+'/bids/gykhList', params, true);
}
// 招标申购单
export async function applyList(params) {
    return post(erpserver+'/bids/applyList', params, true);
}
// 作废/打回申购单
export async function cancel(params) {
    return post(erpserver+'/applybuy/cancel', params, true);
}
//招标详情
export async function bidsDetail(params) {
    return post(erpserver+'/bids/detail', params, true)
}
//发布
export async function publish(params) {
    return post(erpserver+'/bids/publish', params, true)
}
//发布预览
export async function publishView(params) {
    return post(erpserver+'/bids/publishView', params, true)
}
//文件上传
export async function uploadFile(params) {
    return post(erpplatserver+'/system/uploadFile', params, false)
}
//开标
export async function stopBid(params) {
    return post(erpserver+'/bids/stopBid', params, true)
}
//开标详情
export async function resultDetail(params) {
    return post(erpserver+'/bids/resultDetail', params, true)
}
//中标
export async function confirmOffer(params) {
    return post(erpserver+'/bids/confirmOffer', params, true)
}
//作废
export async function cancelResult(params) {
    return post(erpserver+'/bids/cancelResult', params, true)
}
export async function time(params) {
    return post(erpserver+'/attendence/kqtc/time', params, true)
}
//发布中标结果
export async function publishResult(params) {
    return post(erpserver+'/bids/publishResult', params, true)
}
